import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useStatusTemplateContext } from '../StatusTemplateProvider'

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: '20px',
    '& .__name': {
      fontSize: theme.typography.fontSizes.h3
    },
    '& .__desc': {
      fontWeight: theme.typography.weights.light
    }
  }
}))

function StatusTemplateHeader () {
  const classes = useStyles()
  const { statusTemplate } = useStatusTemplateContext()
  return (
    <div className={classes.header}>
      <div className='__name'>{statusTemplate.name}</div>
      <div className='__desc'>{statusTemplate.description}</div>
    </div>
  )
}

export default StatusTemplateHeader
